import { AppliancesDTO } from '@hakimo-ui/hakimo/types';
import { Pagination, Table } from '@hakimo-ui/hakimo/ui-table';
import { Button } from '@hakimo-ui/shared/ui-base';
import { useMemo } from 'react';
import ApplianceCard from './ApplianceCard';
import { getTableData, PAGE_SIZE } from './util';

interface Props {
  response: AppliancesDTO;
  viewMode: 'grid' | 'list';
  page: number;
  loading: boolean;
  onClickRow: (
    id: string,
    event: React.MouseEvent | React.KeyboardEvent
  ) => void;
  onClear: () => void;
  onChangePage: (page: number) => void;
}

export function AppliancesListCard(props: Props) {
  const { response, viewMode, page, loading, onClickRow, onClear } = props;
  const tableData = useMemo(
    () => getTableData(response.items, onClickRow),
    [response.items, onClickRow]
  );

  if (response.items.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 py-16">
        <p className="dark:text-ondark-text-2 text-onlight-text-2">
          No appliances match these filters
        </p>
        <Button onClick={onClear}>Clear all</Button>
      </div>
    );
  }

  const fromIndex = (page - 1) * PAGE_SIZE;
  const toIndex = Math.min(fromIndex + PAGE_SIZE - 1, response.total - 1);
  const footer = (
    <div className="dark:bg-dark-bg border-t bg-white pt-4 dark:border-gray-800">
      <Pagination
        from={fromIndex + 1}
        to={toIndex + 1}
        pageSize={PAGE_SIZE}
        total={response.total}
        disabled={loading}
        onChangePage={props.onChangePage}
      />
    </div>
  );

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto">
        {viewMode === 'list' && <Table data={tableData} />}
        {viewMode === 'grid' && (
          <div className="grid grid-cols-4 gap-4">
            {response.items.map((appliance) => (
              <ApplianceCard key={appliance.id} appliance={appliance} />
            ))}
          </div>
        )}
      </div>
      {footer}
    </div>
  );
}

export default AppliancesListCard;
